import Vue from 'vue';



export default Vue.extend({

  name: 'FontSmallButton',

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggleFontSize(): void {
      this.$emit('onClick');
    }
  }



});
